import { __extends } from "tslib";
import { namespacedClassnames, isPromise } from '../../common';
import * as React from 'react';
import { normalToggleIcon, smallToggleIcon } from './toggle-icons';
import { Icon } from '../icon/icon';
import { Tooltip } from '../tooltip/tooltip';
var Toggle = /** @class */ (function (_super) {
    __extends(Toggle, _super);
    function Toggle() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.elemRef = null;
        _this.unMounted = false;
        _this.state = {
            loading: false
        };
        _this.startLoading = function () {
            var elem = _this.elemRef;
            if (elem && !_this.unMounted) {
                _this.setState({ loading: true, width: elem.offsetWidth });
            }
        };
        _this.stopLoading = function () {
            var elem = _this.elemRef;
            if (elem && !_this.unMounted) {
                _this.setState({ loading: false, width: undefined });
            }
        };
        _this.setRef = function (ref) { return _this.elemRef = ref; };
        _this.toggle = function (e) {
            if (!_this.props.disabled) {
                var result = _this.props.onChange(!_this.props.value, e);
                if (result && isPromise(result)) {
                    _this.startLoading();
                    result.then(_this.stopLoading, _this.stopLoading);
                }
            }
        };
        _this.renderWithTooltip = function (disabled) {
            return typeof disabled !== 'boolean' && !!disabled;
        };
        return _this;
    }
    Toggle.prototype.componentWillUnmount = function () {
        this.unMounted = true;
    };
    Toggle.prototype.render = function () {
        var props = this.props;
        var val = props.value;
        var size = props.size || 'normal';
        var style = props.color && { '--var-color': props.color };
        var classNames = namespacedClassnames('toggle', size, {
            on: val, off: !val, disabled: props.disabled || this.state.loading, loading: this.state.loading,
            'has-tooltip': this.renderWithTooltip(props.disabled),
            'has-color-override': !!props.color,
        });
        var svg = (size === 'normal') ? normalToggleIcon : smallToggleIcon;
        var comp = (React.createElement("span", { style: style, className: classNames, onClick: this.toggle, ref: this.setRef },
            React.createElement(Icon, { icon: svg })));
        return this.renderWithTooltip(props.disabled) ? (React.createElement(Tooltip, { body: props.disabled, relativeToBody: true }, comp)) : comp;
    };
    return Toggle;
}(React.PureComponent));
export { Toggle };
//# sourceMappingURL=toggle.js.map